import { useState, useEffect } from 'react';

export function useIsAndroid() {
  const [isAndroid, setIsAndroid] = useState(false);

  useEffect(() => {
    const checkAndroid = () => {
      // Check if running in Capacitor Android app
      const isCapacitorAndroid = typeof window !== 'undefined' && 
        (window as any).Capacitor && 
        (window as any).Capacitor.isNativePlatform() && 
        /Android/i.test(navigator.userAgent);

      // Check user agent for Android
      const isAndroidUA = /Android/i.test(navigator.userAgent);

      setIsAndroid(isCapacitorAndroid || isAndroidUA);
    };

    checkAndroid();
  }, []);

  return isAndroid;
}

// Hook to ensure back button handler is properly initialized
// Note: This hook is deprecated. Use useAndroidBackNavigation instead.
export function useAndroidBackButton() {
  const isAndroid = useIsAndroid();

  useEffect(() => {
    if (!isAndroid) return;

    console.log('useAndroidBackButton: This hook is deprecated. Use useAndroidBackNavigation instead.');
    
    // No longer needed since we use the new Android back navigation hook
    // The new hook properly handles back button events via Capacitor App.addListener
  }, [isAndroid]);

  return isAndroid;
}
